// extracted by mini-css-extract-plugin
export default {"email_change_modal":"changeEmailAddress_email_change_modal__rz3IX","main_wrapper":"changeEmailAddress_main_wrapper__OlSPD"};